export default {
  primary: '716-796-6976',
};
